import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { GlobalStyle } from 'config/globalStyle';
import store from './config/store';
import App from './App';

const component = (
  <React.StrictMode>
    <Provider store={store}>
      <GlobalStyle />
      <App />
    </Provider>
  </React.StrictMode>
);

const container = document.getElementById('root');

const root = createRoot(container);
root.render(component);
